import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiGatewayService } from 'src/app/services/api-gateway.service';
import { emitInfoMessage, InfoMessageService } from 'src/app/services/info-message.service';
import { activeSubscriptions, formatMoney, OrderLine, orderPages, OrderProduct, SubscriptionOrderService } from 'src/app/services/subscription-order.service';

@Component({
    selector: 'tab-subscriptions-buy',
    templateUrl: './tab-subscriptions-buy.component.html',
    standalone: false
})
export class TabSubscriptionsBuyComponent {
  readonly products = {
    KIT: { label: 'KIT', unit: 'kit' },
    CONNECTIVITY_SINGLE: { label: 'Connectivity only', unit: 'subscription' },
  };
  readonly views = [
    { src: 'assets/subscriptions/ls300-open-top.png', srcset: 'assets/subscriptions/ls300-open-top@2x.png 2x', label: 'Inside, top view', caption: 'Inside the enclosure: main board with satellite modem and batteries' },
    { src: 'assets/subscriptions/ls300-multinode.jpg', label: 'Side view', caption: 'Sealed enclosure with the mounting plate' },
  ];
  view = this.views[0];
  type: OrderProduct;
  other: OrderProduct;
  connectivityToday?: number;
  money = formatMoney;
  pages = orderPages;

  constructor(
    route: ActivatedRoute,
    private gatewayApiService: ApiGatewayService,
    private infoMessageService: InfoMessageService,
    public order: SubscriptionOrderService,
  ) {
    this.type = route.snapshot.data[4];
    this.other = this.type === 'KIT' ? 'CONNECTIVITY_SINGLE' : 'KIT';
    this.getPrices();
    this.getConnectivityToday();
  }

  async getPrices() {
    try {
      await this.order.loadPriceList();
    } catch (error: any) {
      emitInfoMessage("Could not get prices: " + error?.message, this.infoMessageService);
    }
  }

  async getConnectivityToday() {
    try {
      this.connectivityToday = activeSubscriptions((await this.gatewayApiService.getSubscriptions()).body ?? [])
        .reduce((sum, s) => sum + s.capacity_devices, 0);
    } catch (error: any) {
      emitInfoMessage("Could not get subscriptions: " + error?.message, this.infoMessageService);
    }
  }

  get otherLine(): OrderLine | undefined {
    return this.order.lines().find(line => line.type === this.other);
  }

  set(quantity: number) {
    this.order.set(this.type, Math.max(0, Math.floor(quantity) || 0));
  }
}
